import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { years } from "../../../../../Components/Data/Session";
import { url } from "../../../../../Config/Config";
import ViewExamSubjects from "./ViewExamSubjects/ViewExamSubjects";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class AddExamConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionRef: createRef(),
      data: {
        examType: "",
        className: "",
        faculty: "",
        group: "",
        session: new Date().getFullYear().toString(),
        section: "",
        startDate: "",
        endDate: "",
        subjects: [],
      },
      subjectData: {
        name: "",
        date: "",
        startTime: "",
        endTime: "",
        fullMarks: 0,
        passMarks: 0,
      },
      sessionError: "",
      subjectError: "",
      facultyError: "",
      groupError: "",
      subData: [],
      examList: [],
      classList: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.getExamType();
    this.getClasses();
    this.getSubjects();
    if (this.props.editStatus) {
      this.getExamConfigData(this.props.examConfigId);
    }
  }

  getExamType = async () => {
    try {
      const response = await Axios.get(`${url}/api/exam-types`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.examTypes.length !== 0) {
        this.setState({
          examList: response.data.examTypes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getExamType();
      }
    }
  };

  getClasses = async () => {
    try {
      const response = await Axios.get(`${url}/api/schoolclass`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.classes.length !== 0) {
        this.setState({
          classList: response.data.classes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getClasses();
      }
    }
  };

  getSubjects = async () => {
    try {
      const response = await Axios.get(`${url}/api/subjects`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.subjects.length !== 0) {
        this.setState({
          subData: response.data.subjects,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getSubjects();
      }
    }
  };

  getExamConfigData = async (examConfigId) => {
    try {
      const response = await Axios.get(`${url}/api/exams/${examConfigId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.exam.length !== 0) {
        this.setState({
          data: {
            examType: response.data.exam.examType,
            session: response.data.exam.session,
            className: response.data.exam.className,
            faculty: response.data.exam.faculty
              ? response.data.exam.faculty
              : "",
            group: response.data.exam.group ? response.data.exam.group : "",
            section: response.data.exam.section,
            startDate: response.data.exam.startDate,
            endDate: response.data.exam.endDate,
            subjects: response.data.exam.subjects,
          },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getExamConfigData(examConfigId);
      }
    }
  };

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubjectChange = (e) => {
    this.setState({
      subjectData: {
        ...this.state.subjectData,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleEditSubjectChange = (data) => {
    this.setState({
      subjectData: {
        name: data.name,
        date: data.date,
        startTime: data.startTime,
        endTime: data.endTime,
        fullMarks: data.fullMarks,
        passMarks: data.passMarks,
      },
    });
  };

  handleEditSubject = (editIndex, editData) => {
    let newArray = this.state.data.subjects.map((data, index) =>
      index === editIndex ? editData : data
    );
    this.setState({
      data: {
        ...this.state.data,
        subjects: newArray,
      },
    });
  };

  handleDeleteSubject = (index) => {
    const toDel = this.state.data.subjects[index];
    const newArray = this.state.data.subjects.filter((data) => {
      return data.name.toLowerCase().indexOf(toDel.name.toLowerCase());
    });
    this.setState({
      data: { ...this.state.data, subjects: newArray },
    });
  };

  handleSubjectSubmit = (e) => {
    let subjectError = false;
    if (
      this.state.data.subjects.some(
        (data) => data.name === this.state.subjectData.name
      )
    ) {
      subjectError = "Subject already added ";
    } else if (this.state.subjectData.name === "") {
      subjectError = "please enter section name";
    } else {
      subjectError = false;
    }
    if (subjectError) {
      this.setState({
        subjectError,
      });
    }
    if (subjectError === false) {
      this.setState({
        data: {
          ...this.state.data,
          subjects: [...this.state.data.subjects, this.state.subjectData],
        },
        subjectData: {
          name: "",
          date: "",
          startTime: "",
          endTime: "",
          fullMarks: 0,
          passMarks: 0,
        },
      });
    }
  };

  filterFaculty = () => {
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === this.state.data.className)
      .map((filter) => filter.faculty);
    let status = facultyFilter.map((filter) => {
      return filter === null || filter === undefined ? false : true;
    });
    if (status.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  checkError = () => {
    let facultyError = "";
    let groupError = "";
    let subjectError = "";
    let status = this.filterFaculty();

    if (status) {
      if (!this.state.data.faculty) {
        facultyError = "Please Enter Faculty";
      }
    }

    if (this.state.data.faculty) {
      if (!this.state.data.group) {
        groupError = "Please select group ";
      }
    }

    if (this.state.data.subjects.length === 0) {
      subjectError = "Enter at least one subjects.";
    }

    if (facultyError || groupError || subjectError) {
      this.setState({
        facultyError,
        groupError,
        subjectError,
      });
      return true;
    } else {
      this.setState({
        facultyError: "",
        groupError: "",
        subjectError: "",
      });
      return false;
    }
  };

  filterData = (data) => {
    let changedData = { ...data };
    if (!data.faculty) {
      delete changedData.faculty;
    }

    if (!data.group) {
      delete changedData.group;
    }

    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        let changedData = this.filterData(this.state.data);
        let data = { ...changedData };
        if (this.props.editStatus) {
          const editResponse = await Axios.put(
            `${url}/api/exams/${this.props.examConfigId}`,
            data,
            { headers: { Authorization: `Bearer ${this.props.adminToken}` } }
          );
          if (
            editResponse.data.message === "Exam config updated successfully"
          ) {
            this.props.history.push(`/administration/examconfig`);
          }
        } else {
          const response = await Axios.post(`${url}/api/exams`, data, {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          });
          if (response.data.message === "Exam config added successfully") {
            this.props.history.push(`/administration/examconfig`);
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    const classFilter = this.state.classList.map((data) => data.className);
    const facultyFilter = this.state.classList
      .filter((data) => data.className === this.state.data.className)
      .map((data) => data.faculty);
    const groupFilter = this.state.classList
      .filter((data) => data.faculty === this.state.data.faculty)
      .map((data) => data.group);
    const sectionFilter =
      this.state.data.faculty && this.state.data.group
        ? this.state.classList
            .filter(
              (data) =>
                data.className === this.state.data.className &&
                data.faculty === this.state.data.faculty &&
                data.group === this.state.data.group
            )
            .map((data) => data.section)
        : this.state.classList
            .filter((data) => data.className === this.state.data.className)
            .map((data) => data.section);
    const subjectFilter =
      this.state.data.faculty && this.state.data.group
        ? this.state.classList
            .filter(
              (data) =>
                data.className === this.state.data.className &&
                data.faculty === this.state.data.faculty &&
                data.group === this.state.data.group
            )
            .map((data) => data.subjects)
        : this.state.classList
            .filter((data) => data.className === this.state.data.className)
            .map((data) => data.subjects);

    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          {this.props.editStatus ? (
            <PageTitle title="Edit Exam Config" />
          ) : (
            <PageTitle title="Add New Exam Configuration" />
          )}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={4} xl={3} lg={3}>
              <Paper className={classes.paper}>
                <form onSubmit={this.handleSubmit}>
                  <div>
                    <TextField
                      name="examType"
                      select
                      label="Exam Type"
                      required
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      SelectProps={{
                        native: true,
                      }}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.examType}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Any One</option>
                      {this.state.examList.map((exam, index) => (
                        <option key={index} value={exam.name}>
                          {exam.name}
                        </option>
                      ))}
                    </TextField>

                    <TextField
                      name="session"
                      select
                      label="Session"
                      required
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      placeholder="Enter Session year"
                      error={this.state.sessionError ? true : false}
                      helperText={this.state.sessionError}
                      SelectProps={{
                        native: true,
                      }}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.session}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Model Year</option>
                      {years.map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                    </TextField>

                    <TextField
                      name="className"
                      select
                      label="Class Name"
                      required
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      placeholder="Enter the name of className"
                      SelectProps={{
                        native: true,
                      }}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.className}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Any One</option>
                      {classFilter
                        .filter(
                          (value, index) => classFilter.indexOf(value) === index
                        )
                        .map((schoolClass, index) => (
                          <option key={index} value={schoolClass}>
                            {schoolClass}
                          </option>
                        ))}
                    </TextField>

                    <TextField
                      name="faculty"
                      select
                      label="Faculty"
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      error={this.state.facultyError ? true : false}
                      helperText={
                        this.state.facultyError
                          ? this.state.facultyError
                          : facultyFilter.includes(null)
                          ? "The class you selected doesn't have any faculty"
                          : "Select the faculty of the class"
                      }
                      SelectProps={{ native: true }}
                      placeholder="Enter the name of faculty"
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.faculty}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Any One</option>
                      {facultyFilter.includes(null) === false &&
                        facultyFilter
                          .filter(
                            (value, index) =>
                              facultyFilter.indexOf(value) === index
                          )
                          .map((faculty, index) => (
                            <option key={index} value={faculty}>
                              {faculty}
                            </option>
                          ))}
                    </TextField>

                    <TextField
                      name="group"
                      select
                      label="Group"
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      error={this.state.groupError ? true : false}
                      helperText={
                        this.state.groupError
                          ? this.state.groupError
                          : facultyFilter.includes(null) ||
                            groupFilter.includes(null)
                          ? "The faculty you selected doesn't have any group"
                          : "Select the group of the class"
                      }
                      SelectProps={{ native: true }}
                      placeholder="Enter the name of group"
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.group}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Any One</option>
                      {groupFilter.includes(null) === false &&
                        groupFilter
                          .filter(
                            (value, index) =>
                              groupFilter.indexOf(value) === index
                          )
                          .map((group, index) => (
                            <option key={index} value={group}>
                              {group}
                            </option>
                          ))}
                    </TextField>

                    <TextField
                      name="section"
                      select
                      required
                      label="Section Name"
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      SelectProps={{ native: true }}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.section}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Any One</option>
                      {sectionFilter.includes(null) === false &&
                        sectionFilter.map((section) =>
                          section.map((data, index) => (
                            <option key={index} value={data.name}>
                              {data.name}
                            </option>
                          ))
                        )}
                    </TextField>
                    <TextField
                      name="startDate"
                      type="date"
                      required
                      label="Start Date"
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.startDate}
                      onChange={this.handleChange}
                    />
                    <TextField
                      name="endDate"
                      type="date"
                      required
                      label="End Date"
                      fullWidth
                      variant="outlined"
                      margin="normal"
                      InputProps={{
                        classes: {
                          notchedOutline: classes.notchedOutline,
                          focused: classes.focused,
                        },
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                        shrink: true,
                      }}
                      value={this.state.data.endDate}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div style={{ display: "flex", alignItem: "center" }}>
                    <Button
                      type="submit"
                      aria-label="Submit"
                      variant="outlined"
                      className={classes.buttonStyle}
                    >
                      Submit
                    </Button>
                    {this.state.loading && <FormLoader />}
                  </div>
                </form>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={8} xl={9} lg={9}>
              <br />
              <Paper className={classes.paper}>
                <ViewExamSubjects
                  subjectError={this.state.subjectError}
                  data={this.state.data}
                  subjectData={this.state.subjectData}
                  subjects={this.state.data.subjects}
                  subjectList={subjectFilter.length !== 0 ? subjectFilter : []}
                  handleSubjectChange={this.handleSubjectChange}
                  handleEditSubjectChange={this.handleEditSubjectChange}
                  handleSubjectSubmit={this.handleSubjectSubmit}
                  handleDeleteSubject={this.handleDeleteSubject}
                  handleEditSubject={this.handleEditSubject}
                />
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddExamConfig)));
